import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationIT from './it/general.json'
import translationEN from './en/general.json'
import translationDE from './de/general.json'

export const resources = {
  en: {
    translation: translationEN,
  },
  it: {
    translation: translationIT,
  },
  de: {
    translation: translationDE,
  },
} as const

export const fallbackLng = 'en'
export const handledResources = Object.keys(resources)
// NOTE: la lingua, viene rilevata dal browser utilizzando la strategia di default: (https://github.com/i18next/i18next-browser-languageDetector#detector-options)
// Il primo criterio utilizzato è il parametro su querystring [?lng=xx] es: https://siteurl.ext/?lng=en

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: fallbackLng,
    interpolation: {
      escapeValue: false,
    },
    resources,
  })

export default i18n
